import styled from 'styled-components'

export const ValidatedLabel = styled.span`  
  :before {
    display: ${props => props['data-error'] ? 'inline-block' : 'none'};
    margin-inline-end: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: "*";
  }
`

export const BlueIconOnHover = styled.div`
  a {
    color: rgba(0,0,0,0.45);
  }

  :hover a {
    color: #1677ff;
  }
`